import React from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once, amount: 0.15 }}
        transition={{ duration: 0.7, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
    <span className={`block overflow-hidden ${className}`}>
        <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.9, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </span>
);

export const FadeIn = ({ children, delay = 0, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay, ease: "easeOut" }}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
    <div className={`text-xs tracking-[0.22em] uppercase font-bold text-forest-600 ${className}`}>{children}</div>
);

export const SectionTitle = ({ eyebrow, title, sub, align = "left" }) => (
    <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
        {eyebrow && <Reveal><Eyebrow className="mb-3">{eyebrow}</Eyebrow></Reveal>}
        <Reveal delay={0.05}>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-[2.75rem] tracking-tight font-semibold text-forest-900 text-balance">
                {title}
            </h2>
        </Reveal>
        {sub && (
            <Reveal delay={0.1}>
                <p className="mt-4 text-body text-lg leading-relaxed">{sub}</p>
            </Reveal>
        )}
    </div>
);